import { ApiDocs } from '../components/docs/ApiDocs';
import { apiFetch, LIGHTNING_API_BASE } from '../utils/api';

/**
 * Merch's integration reference, rendered from the spec merch itself serves.
 *
 * Everything on the page comes from that spec — see
 * {@link ../components/docs/ApiDocs.ApiDocs} — so this file only has to say
 * which app's spec to read. Module scope, not a closure per render: `ApiDocs`
 * refetches when the helper's identity changes.
 */
const fetchSpec = (path: string) => apiFetch(path, { app: 'lightning' });

export function DocsPage() {
  return <ApiDocs apiBase={LIGHTNING_API_BASE} fetchSpec={fetchSpec} />;
}
